module.exports = __webpack_public_path__ + "static/media/icon-cerramiento.4301af00.svg";